import React from "react";
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  Divider,
  ListItemText,
  Typography,
} from "@mui/material";
import * as Assets from "../Icon/assets";
import { useLocation } from "react-router-dom";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export const ShortcutManual = () => {
  const location = useLocation();
  const isModeration = location.pathname.includes("/moderation");

  return (
    <>
      <>
        <Box
          sx={{
            borderRadius: 1.5,
            border: 1,
            borderColor: "#79747e",
            minWidth: "243px",
            maxWidth: "243px",
            color: "#79747e",
            ml: "7px",
          }}
        >
          <ListItemText
            sx={{ textAlign: "center" }}
            primary={
              <Typography sx={{ fontSize: 13 }}>
                List Keyboard Shortcuts
              </Typography>
            }
          />

          <Divider sx={{ backgroundColor: "white" }} />
          <ListItem sx={{ pt: "4px", pb: "4px" }}>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: "#79747e",
                  color: "white",
                  width: 20,
                  height: 20,
                  fontSize: 12,
                }}
                variant="rounded"
              >
                M
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: "11px" }}>
                  Go to Moderation List
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ pt: "4px", pb: "4px" }}>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: "#79747e",
                  color: "white",
                  width: 20,
                  height: 20,
                  fontSize: 12,
                }}
                variant="rounded"
              >
                T
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: "11px" }}>
                  Go to Template List
                </Typography>
              }
            />
          </ListItem>

          <ListItem sx={{ pt: "4px", pb: "4px" }}>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: "#79747e",
                  color: "white",
                  width: 20,
                  height: 20,
                  fontSize: 12,
                }}
                variant="rounded"
              >
                H
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: "11px" }}>
                  Go to History List
                </Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ pt: "4px", pb: "4px" }}>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: "#79747e",
                  color: "white",
                  width: 20,
                  height: 20,
                  fontSize: 12,
                }}
                variant="rounded"
              >
                ➡
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: "11px" }}>Next Page</Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ pt: "4px", pb: 0 }}>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: "#79747e",
                  color: "white",
                  width: 20,
                  height: 20,
                  fontSize: 12,
                }}
                variant="rounded"
              >
                ⬅
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: "11px" }}>Previous Page</Typography>
              }
            />
          </ListItem>
          <ListItem sx={{ pt: 0, pb: 0 }}>
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: "#79747e",
                  color: "white",
                  width: 20,
                  height: 20,
                  fontSize: 12,
                }}
                variant="rounded"
              >
                G
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography sx={{ fontSize: "11px" }}>
                  Start reviewing <br /> the oldest template
                </Typography>
              }
            />
          </ListItem>
        </Box>
        <br />
        {!isModeration && (
          <Box
            sx={{
              borderRadius: 1.5,
              border: 1,
              borderColor: "#79747e",
              minWidth: "243px",
              maxWidth: "243px",
              color: "#79747e",
              ml: "7px",
            }}
          >
            <ListItemText
              sx={{ textAlign: "center" }}
              primary={
                <Typography sx={{ fontSize: 13 }}>
                  Detail Keyboard Shortcuts
                </Typography>
              }
            />
            <Divider sx={{ backgroundColor: "white" }} />

            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  S
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Start Review
                  </Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  C
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Copy description to clipboard
                  </Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  D
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Download optimized kine file
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ pt: 0, pb: 0 }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  G
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Start reviewing <br /> the oldest template
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  V
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Moderation Save
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  Q
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Go to uploaded templates
                  </Typography>
                }
              />
            </ListItem>

            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  R
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>Reject</Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    width: 50,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  P or E
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>Publish</Typography>
                }
              />
            </ListItem>
            <ListItem sx={{ pt: "4px", pb: "4px" }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",

                    paddingLeft: "10px",
                    paddingRight: "10px",
                    width: 65,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  Space
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Select Video
                  </Typography>
                }
                sx={{ paddingLeft: "10px" }}
              />
            </ListItem>
            <ListItem sx={{ pt: 0, pb: 0 }}>
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: "#79747e",
                    color: "white",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    width: 125,
                    height: 20,
                    fontSize: 12,
                  }}
                  variant="rounded"
                >
                  Space + Space
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ fontSize: "11px" }}>
                    Select and <br />
                    play a video
                  </Typography>
                }
                sx={{ paddingLeft: "10px" }}
              />
            </ListItem>
          </Box>
        )}
      </>

      <br />
      <Box
        sx={{
          borderRadius: 1.5,
          border: 1,
          borderColor: "#79747e",
          minWidth: "243px",
          maxWidth: "243px",
          color: "#79747e",
          ml: "7px",
        }}
      >
        <ListItemText
          sx={{ textAlign: "center" }}
          primary={
            <Typography sx={{ fontSize: 13 }}>Icon Description</Typography>
          }
        />
        <Divider sx={{ backgroundColor: "white" }} />

        <ListItem sx={{ pt: "4px", pb: "4px" }}>
          <ListItemAvatar>
            <Avatar
              sx={{
                color: "white",
                width: 20,
                height: 20,
                fontSize: 12,
              }}
              variant="rounded"
              src={Assets.Subscribe}
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography sx={{ fontSize: "11px" }}>Subscribe</Typography>
            }
          />
        </ListItem>
        <ListItem sx={{ pt: "4px", pb: "4px" }}>
          <ListItemAvatar>
            <Avatar
              sx={{
                color: "white",
                width: 20,
                height: 20,
                fontSize: 12,
              }}
              variant="rounded"
              src={Assets.Translation}
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography sx={{ fontSize: "11px" }}>Translation</Typography>
            }
          />
        </ListItem>
        <ListItem sx={{ pt: "4px", pb: "4px" }}>
          <ListItemAvatar>
            <Avatar
              sx={{
                color: "white",
                width: 20,
                height: 20,
                fontSize: 12,
              }}
              variant="rounded"
              src={Assets.Modify}
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography sx={{ fontSize: "11px" }}>
                Moderation Modify
              </Typography>
            }
          />
        </ListItem>
        <ListItem sx={{ pt: "4px", pb: "4px" }}>
          <ListItemAvatar>
            <Avatar
              sx={{
                color: "white",
                width: 20,
                height: 20,
                fontSize: 12,
              }}
              variant="rounded"
              src={Assets.Copy}
            />
          </ListItemAvatar>
          <ListItemText
            primary={<Typography sx={{ fontSize: "11px" }}>Copy</Typography>}
          />
        </ListItem>
        <ListItem sx={{ pt: "4px", pb: "4px" }}>
          <ListItemAvatar>
            <Avatar
              sx={{
                color: "white",
                width: 20,
                height: 20,
                fontSize: 12,
              }}
              variant="rounded"
              src={Assets.NewWindows}
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography sx={{ fontSize: "11px" }}>New Window</Typography>
            }
          />
        </ListItem>
        <ListItem sx={{ pt: "4px", pb: "4px" }}>
          <ListItemAvatar>
            <VisibilityOffIcon />
          </ListItemAvatar>
          <ListItemText
            primary={<Typography sx={{ fontSize: "11px" }}>Blind</Typography>}
          />
        </ListItem>
      </Box>
    </>
  );
};

export default ShortcutManual;
